import { useTranslation } from "react-i18next";
import "./ServicesStyle.css";
import arrow from "../../assets/arrow.png";
import Video1 from "../../assets/Video1.mp4";
import Video2 from "../../assets/video2.mp4";
import { useState } from "react";
import { FaBrain, FaLink, FaLightbulb, FaHeart } from "react-icons/fa";

const Services = ({ id }) => {
  const { t, i18n } = useTranslation();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(0);
  const videos = [Video1, Video2];

  const openPopup = () => setIsPopupOpen(true);
  const closePopup = () => {
    setIsPopupOpen(false);
    setCurrentVideo(0);
  };
  const nextVideo = () => setCurrentVideo((prev) => (prev + 1) % videos.length);
  const prevVideo = () =>
    setCurrentVideo((prev) => (prev - 1 + videos.length) % videos.length);

  return (
    <section className="services-container" id={id} dir={i18n.dir()}>
      <div className="container">
        <h1 className="services-title">{t("services.title")}</h1>
        <div className="img-cont">
          <img
            src={arrow}
            alt={t("services.arrowAlt")}
            className="subtitle-arrow"
          />
          <div className="txtt">
            <div className="first">{t("services.firstText")}</div>
            <div className="second">{t("services.secondText")}</div>
          </div>
        </div>
        <div className="services-wrapper">
          <div className="service-card">
            <div className="service-icon">
              <FaBrain size={24} color="white" />
            </div>
            <h3 className="service-title">
              {t("services.cards.mindsetShift.title")}
            </h3>
            <p className="service-text">
              {t("services.cards.mindsetShift.text")}
            </p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <FaLink size={24} color="white" />
            </div>
            <h3 className="service-title">
              {t("services.cards.creativeConnection.title")}
            </h3>
            <p className="service-text">
              {t("services.cards.creativeConnection.text")}
            </p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <FaLightbulb size={24} color="white" />
            </div>
            <h3 className="service-title">
              {t("services.cards.logicalCreativity.title")}
            </h3>
            <p className="service-text">
              {t("services.cards.logicalCreativity.text")}
            </p>
          </div>
          <div className="service-card">
            <div className="service-icon">
              <FaHeart size={24} color="white" />
            </div>
            <h3 className="service-title">
              {t("services.cards.targetedHealthcare.title")}
            </h3>
            <p className="service-text">
              {t("services.cards.targetedHealthcare.text")}
            </p>
          </div>
        </div>
        <button
          className="view-videos-btn"
          onClick={openPopup}
          aria-label="Watch service explanation videos"
        >
          {t("services.viewVideos")}
        </button>
      </div>
      {isPopupOpen && (
        <div className="popup-overlay" onClick={closePopup}>
          <div
            className="popup-content servContent"
            onClick={(e) => e.stopPropagation()}
          >
            <video
              width="560"
              height="315"
              controls
              src={videos[currentVideo]}
              title="Video"
              aria-label="Service promotional video"
            ></video>
            <div className="popup-controls servControl">
              <button className="popup-arrow prev" onClick={prevVideo}>
                ←
              </button>
              <button className="popup-arrow next" onClick={nextVideo}>
                →
              </button>
            </div>
            <button className="popup-close" onClick={closePopup}>
              ×
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default Services;
